import {
    Action,
    configureStore,
    ThunkAction,
  } from '@reduxjs/toolkit';
  import dashboardReducer from 'features/dashboard/dashboardSlice';
  import filterReducer from 'features/filters/filterSlice';
  import downloadReducer from 'features/downloads/downloadSlice';
  import notificationReducer from 'features/notifications/notificationSlice';
  import demoReducer from 'features/demos/demoSlice';
  import contactusReducer from 'features/contactus/contactUsSlice';
  import advertisementReducer from 'features/advertisement/advertisementSlice';
  import performanceReducer from 'features/performance/performanceSlice';

  export const store = configureStore({
    reducer: {
  // This is where we add reducers.
  // Since we don't have any yet, leave this empty
        dashboard: dashboardReducer,
        filters: filterReducer,
        downloads: downloadReducer,
        notifications: notificationReducer,
        demos: demoReducer,
        contactus: contactusReducer,
        advertisements: advertisementReducer,
        performance: performanceReducer
    },
  });
  
  export type AppDispatch = typeof store.dispatch;
  export type RootState = ReturnType<typeof store.getState>;
  export type AppThunk<ReturnType = void> = ThunkAction<
     ReturnType,
     RootState,
     unknown,
     Action<string>
   >;